import { EventsHub } from 'wootils/esm/shared';

class AppEvents extends EventsHub {

}

export default AppEvents;
